import { Controller, type Control } from 'react-hook-form';
import { AutocompleteSingleSelect, Input, Label } from '@shigo-ui/ui';

import type { AssignedAgency } from '../../../../auth/agencyAccess';
import { dashboardT } from '../../../../../lib/messages';
import type { BrandDialogFormValue } from './BrandDialog.schema';

type BrandAgencyFieldProps = {
  control: Control<BrandDialogFormValue>;
  /** Fixed agency shown read-only; otherwise the user picks one of `agencies`. */
  agency: AssignedAgency | null | undefined;
  agencies: readonly AssignedAgency[];
  error: string | undefined;
};

export function BrandAgencyField({ control, agency, agencies, error }: BrandAgencyFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor="brand-agency">{dashboardT('agencyAssignment.label')} *</Label>
      {agency ? (
        <Input id="brand-agency" value={agency.name} disabled />
      ) : (
        <Controller
          name="agencyId"
          control={control}
          render={({ field }) => (
            <AutocompleteSingleSelect
              label={dashboardT('agencyAssignment.label')}
              value={field.value ?? ''}
              onValueChange={field.onChange}
              options={agencies.map(({ id, name }) => ({ id, label: name }))}
              placeholder={dashboardT('agencyAssignment.select')}
            />
          )}
        />
      )}
      {error ? (
        <p role="alert" className="text-destructive text-xs">
          {error}
        </p>
      ) : null}
    </div>
  );
}
